import { createSelector } from 'reselect';

const getIsPremiumUserHelper = (state) => state.config?.isPremiumUser;

export const getIsPremiumUser = createSelector(
    [ getIsPremiumUserHelper ],
    ( isPremiumUser ) => {
        return {
            isPremiumUser: isPremiumUser
        }
    }
);
